// Ported from com.codemovr.libs.commons.sdo.MeasureType & UnitOfMeasure

export interface MeasureTypeEntry {
    key: string;
    display: string;
}

export const MEASURE_TYPES: MeasureTypeEntry[] = [
    {key: 'LENGTH', display: 'Length'},
    {key: 'AREA', display: 'Area'},
    {key: 'VOLUME', display: 'Volume'},
    {key: 'MASS', display: 'Mass / Weight'},
    {key: 'TIME', display: 'Time / Duration'},
    {key: 'SPEED', display: 'Speed'},
    {key: 'ACCELERATION', display: 'Acceleration'},
    {key: 'TEMPERATURE', display: 'Temperature'},
    {key: 'ANGLE', display: 'Angle'},
    {key: 'FREQUENCY', display: 'Frequency'},
    {key: 'FORCE', display: 'Force'},
    {key: 'PRESSURE', display: 'Pressure'},
    {key: 'ENERGY', display: 'Energy'},
    {key: 'POWER', display: 'Power'},
    {key: 'VOLTAGE', display: 'Voltage'},
    {key: 'CURRENT', display: 'Electric Current'},
    {key: 'RESISTANCE', display: 'Electrical Resistance'},
    {key: 'FLOW_RATE', display: 'Flow Rate'},
    {key: 'DATA_SIZE', display: 'Data Size'},
];

export type SystemOfUnits = 'SI' | 'IMPERIAL' | 'OTHER';

export interface UnitOfMeasureEntry {
    key: string;
    type: string;
    display: string;
    symbol: string;
    system: SystemOfUnits;
}

export const UNITS_OF_MEASURE: UnitOfMeasureEntry[] = [
    // LENGTH
    {key: 'NANOMETER', type: 'LENGTH', display: 'Nanometer', symbol: 'nm', system: 'SI'},
    {key: 'MICROMETER', type: 'LENGTH', display: 'Micrometer', symbol: 'µm', system: 'SI'},
    {key: 'MILLIMETER', type: 'LENGTH', display: 'Millimeter', symbol: 'mm', system: 'SI'},
    {key: 'CENTIMETER', type: 'LENGTH', display: 'Centimeter', symbol: 'cm', system: 'SI'},
    {key: 'METER', type: 'LENGTH', display: 'Meter', symbol: 'm', system: 'SI'},
    {key: 'KILOMETER', type: 'LENGTH', display: 'Kilometer', symbol: 'km', system: 'SI'},
    {key: 'INCH', type: 'LENGTH', display: 'Inch', symbol: 'in', system: 'IMPERIAL'},
    {key: 'FOOT', type: 'LENGTH', display: 'Foot', symbol: 'ft', system: 'IMPERIAL'},
    {key: 'YARD', type: 'LENGTH', display: 'Yard', symbol: 'yd', system: 'IMPERIAL'},
    {key: 'MILE', type: 'LENGTH', display: 'Mile', symbol: 'mi', system: 'IMPERIAL'},
    {key: 'NAUTICAL_MILE', type: 'LENGTH', display: 'Nautical mile', symbol: 'nmi', system: 'OTHER'},

    // AREA
    {key: 'SQUARE_MILLIMETER', type: 'AREA', display: 'Square millimeter', symbol: 'mm²', system: 'SI'},
    {key: 'SQUARE_CENTIMETER', type: 'AREA', display: 'Square centimeter', symbol: 'cm²', system: 'SI'},
    {key: 'SQUARE_METER', type: 'AREA', display: 'Square meter', symbol: 'm²', system: 'SI'},
    {key: 'SQUARE_KILOMETER', type: 'AREA', display: 'Square kilometer', symbol: 'km²', system: 'SI'},
    {key: 'HECTARE', type: 'AREA', display: 'Hectare', symbol: 'ha', system: 'SI'},
    {key: 'ACRE', type: 'AREA', display: 'Acre', symbol: 'ac', system: 'IMPERIAL'},
    {key: 'SQUARE_INCH', type: 'AREA', display: 'Square inch', symbol: 'in²', system: 'IMPERIAL'},
    {key: 'SQUARE_FOOT', type: 'AREA', display: 'Square foot', symbol: 'ft²', system: 'IMPERIAL'},
    {key: 'SQUARE_YARD', type: 'AREA', display: 'Square yard', symbol: 'yd²', system: 'IMPERIAL'},
    {key: 'SQUARE_MILE', type: 'AREA', display: 'Square mile', symbol: 'mi²', system: 'IMPERIAL'},

    // VOLUME
    {key: 'MILLILITER', type: 'VOLUME', display: 'Milliliter', symbol: 'mL', system: 'SI'},
    {key: 'LITER', type: 'VOLUME', display: 'Liter', symbol: 'L', system: 'SI'},
    {key: 'CUBIC_CENTIMETER', type: 'VOLUME', display: 'Cubic centimeter', symbol: 'cm³', system: 'SI'},
    {key: 'CUBIC_METER', type: 'VOLUME', display: 'Cubic meter', symbol: 'm³', system: 'SI'},
    {key: 'TEASPOON_US', type: 'VOLUME', display: 'Teaspoon (US)', symbol: 'tsp', system: 'IMPERIAL'},
    {key: 'TABLESPOON_US', type: 'VOLUME', display: 'Tablespoon (US)', symbol: 'tbsp', system: 'IMPERIAL'},
    {key: 'FLUID_OUNCE_US', type: 'VOLUME', display: 'Fluid ounce (US)', symbol: 'fl oz', system: 'IMPERIAL'},
    {key: 'CUP_US', type: 'VOLUME', display: 'Cup (US)', symbol: 'cup', system: 'IMPERIAL'},
    {key: 'PINT_US', type: 'VOLUME', display: 'Pint (US)', symbol: 'pt', system: 'IMPERIAL'},
    {key: 'QUART_US', type: 'VOLUME', display: 'Quart (US)', symbol: 'qt', system: 'IMPERIAL'},
    {key: 'GALLON_US', type: 'VOLUME', display: 'Gallon (US)', symbol: 'gal', system: 'IMPERIAL'},
    {key: 'CUBIC_INCH', type: 'VOLUME', display: 'Cubic inch', symbol: 'in³', system: 'IMPERIAL'},
    {key: 'CUBIC_FOOT', type: 'VOLUME', display: 'Cubic foot', symbol: 'ft³', system: 'IMPERIAL'},

    // MASS / WEIGHT
    {key: 'MICROGRAM', type: 'MASS', display: 'Microgram', symbol: 'µg', system: 'SI'},
    {key: 'MILLIGRAM', type: 'MASS', display: 'Milligram', symbol: 'mg', system: 'SI'},
    {key: 'GRAM', type: 'MASS', display: 'Gram', symbol: 'g', system: 'SI'},
    {key: 'KILOGRAM', type: 'MASS', display: 'Kilogram', symbol: 'kg', system: 'SI'},
    {key: 'METRIC_TONNE', type: 'MASS', display: 'Metric ton', symbol: 't', system: 'SI'},
    {key: 'OUNCE', type: 'MASS', display: 'Ounce', symbol: 'oz', system: 'IMPERIAL'},
    {key: 'POUND', type: 'MASS', display: 'Pound', symbol: 'lb', system: 'IMPERIAL'},
    {key: 'STONE', type: 'MASS', display: 'Stone', symbol: 'st', system: 'IMPERIAL'},
    {key: 'SHORT_TON_US', type: 'MASS', display: 'Short ton (US)', symbol: 'ton', system: 'IMPERIAL'},
    {key: 'LONG_TON_UK', type: 'MASS', display: 'Long ton (UK)', symbol: 'long ton', system: 'IMPERIAL'},

    // TIME / DURATION
    {key: 'NANOSECOND', type: 'TIME', display: 'Nanosecond', symbol: 'ns', system: 'SI'},
    {key: 'MICROSECOND', type: 'TIME', display: 'Microsecond', symbol: 'µs', system: 'SI'},
    {key: 'MILLISECOND', type: 'TIME', display: 'Millisecond', symbol: 'ms', system: 'SI'},
    {key: 'SECOND', type: 'TIME', display: 'Second', symbol: 's', system: 'SI'},
    {key: 'MINUTE', type: 'TIME', display: 'Minute', symbol: 'min', system: 'OTHER'},
    {key: 'HOUR', type: 'TIME', display: 'Hour', symbol: 'h', system: 'OTHER'},
    {key: 'DAY', type: 'TIME', display: 'Day', symbol: 'd', system: 'OTHER'},

    // SPEED
    {key: 'METERS_PER_SECOND', type: 'SPEED', display: 'Meters per second', symbol: 'm/s', system: 'SI'},
    {key: 'KILOMETERS_PER_HOUR', type: 'SPEED', display: 'Kilometers per hour', symbol: 'km/h', system: 'SI'},
    {key: 'FEET_PER_SECOND', type: 'SPEED', display: 'Feet per second', symbol: 'ft/s', system: 'IMPERIAL'},
    {key: 'MILES_PER_HOUR', type: 'SPEED', display: 'Miles per hour', symbol: 'mph', system: 'IMPERIAL'},
    {key: 'KNOT', type: 'SPEED', display: 'Knot', symbol: 'kt', system: 'OTHER'},

    // ACCELERATION
    {key: 'METERS_PER_SECOND_SQUARED', type: 'ACCELERATION', display: 'Meters per second²', symbol: 'm/s²', system: 'SI'},
    {key: 'FEET_PER_SECOND_SQUARED', type: 'ACCELERATION', display: 'Feet per second²', symbol: 'ft/s²', system: 'IMPERIAL'},
    {key: 'STANDARD_GRAVITY', type: 'ACCELERATION', display: 'Standard gravity', symbol: 'g₀', system: 'OTHER'},

    // TEMPERATURE
    {key: 'CELSIUS', type: 'TEMPERATURE', display: 'Celsius', symbol: '°C', system: 'SI'},
    {key: 'FAHRENHEIT', type: 'TEMPERATURE', display: 'Fahrenheit', symbol: '°F', system: 'IMPERIAL'},
    {key: 'KELVIN', type: 'TEMPERATURE', display: 'Kelvin', symbol: 'K', system: 'SI'},

    // ANGLE
    {key: 'DEGREE', type: 'ANGLE', display: 'Degree', symbol: '°', system: 'OTHER'},
    {key: 'RADIAN', type: 'ANGLE', display: 'Radian', symbol: 'rad', system: 'SI'},
    {key: 'REVOLUTION', type: 'ANGLE', display: 'Revolution', symbol: 'rev', system: 'OTHER'},

    // FREQUENCY
    {key: 'HERTZ', type: 'FREQUENCY', display: 'Hertz', symbol: 'Hz', system: 'SI'},
    {key: 'KILOHERTZ', type: 'FREQUENCY', display: 'Kilohertz', symbol: 'kHz', system: 'SI'},
    {key: 'MEGAHERTZ', type: 'FREQUENCY', display: 'Megahertz', symbol: 'MHz', system: 'SI'},
    {key: 'GIGAHERTZ', type: 'FREQUENCY', display: 'Gigahertz', symbol: 'GHz', system: 'SI'},
    {key: 'RPM', type: 'FREQUENCY', display: 'Revolutions per minute', symbol: 'rpm', system: 'OTHER'},

    // FORCE
    {key: 'NEWTON', type: 'FORCE', display: 'Newton', symbol: 'N', system: 'SI'},
    {key: 'KILONEWTON', type: 'FORCE', display: 'Kilonewton', symbol: 'kN', system: 'SI'},
    {key: 'POUND_FORCE', type: 'FORCE', display: 'Pound-force', symbol: 'lbf', system: 'IMPERIAL'},

    // PRESSURE
    {key: 'PASCAL', type: 'PRESSURE', display: 'Pascal', symbol: 'Pa', system: 'SI'},
    {key: 'KILOPASCAL', type: 'PRESSURE', display: 'Kilopascal', symbol: 'kPa', system: 'SI'},
    {key: 'MEGAPASCAL', type: 'PRESSURE', display: 'Megapascal', symbol: 'MPa', system: 'SI'},
    {key: 'BAR', type: 'PRESSURE', display: 'Bar', symbol: 'bar', system: 'OTHER'},
    {key: 'ATMOSPHERE', type: 'PRESSURE', display: 'Standard atmosphere', symbol: 'atm', system: 'OTHER'},
    {key: 'PSI', type: 'PRESSURE', display: 'Pounds per square inch', symbol: 'psi', system: 'IMPERIAL'},

    // ENERGY
    {key: 'JOULE', type: 'ENERGY', display: 'Joule', symbol: 'J', system: 'SI'},
    {key: 'KILOJOULE', type: 'ENERGY', display: 'Kilojoule', symbol: 'kJ', system: 'SI'},
    {key: 'WATT_HOUR', type: 'ENERGY', display: 'Watt-hour', symbol: 'Wh', system: 'OTHER'},
    {key: 'KILOWATT_HOUR', type: 'ENERGY', display: 'Kilowatt-hour', symbol: 'kWh', system: 'OTHER'},
    {key: 'CALORIE', type: 'ENERGY', display: 'Calorie', symbol: 'cal', system: 'OTHER'},
    {key: 'KILOCALORIE', type: 'ENERGY', display: 'Kilocalorie', symbol: 'kcal', system: 'OTHER'},

    // POWER
    {key: 'WATT', type: 'POWER', display: 'Watt', symbol: 'W', system: 'SI'},
    {key: 'KILOWATT', type: 'POWER', display: 'Kilowatt', symbol: 'kW', system: 'SI'},
    {key: 'MEGAWATT', type: 'POWER', display: 'Megawatt', symbol: 'MW', system: 'SI'},
    {key: 'HORSEPOWER', type: 'POWER', display: 'Horsepower', symbol: 'hp', system: 'IMPERIAL'},

    // VOLTAGE
    {key: 'VOLT', type: 'VOLTAGE', display: 'Volt', symbol: 'V', system: 'SI'},

    // ELECTRIC CURRENT
    {key: 'AMPERE', type: 'CURRENT', display: 'Ampere', symbol: 'A', system: 'SI'},
    {key: 'MILLIAMPERE', type: 'CURRENT', display: 'Milliampere', symbol: 'mA', system: 'SI'},

    // ELECTRICAL RESISTANCE
    {key: 'OHM', type: 'RESISTANCE', display: 'Ohm', symbol: 'Ω', system: 'SI'},

    // FLOW RATE
    {key: 'LITERS_PER_SECOND', type: 'FLOW_RATE', display: 'Liters per second', symbol: 'L/s', system: 'SI'},
    {key: 'LITERS_PER_MINUTE', type: 'FLOW_RATE', display: 'Liters per minute', symbol: 'L/min', system: 'SI'},
    {key: 'CUBIC_METERS_PER_HOUR', type: 'FLOW_RATE', display: 'Cubic meters per hour', symbol: 'm³/h', system: 'SI'},
    {key: 'GALLONS_PER_MINUTE', type: 'FLOW_RATE', display: 'Gallons per minute', symbol: 'gpm', system: 'IMPERIAL'},

    // DATA SIZE
    {key: 'BYTE', type: 'DATA_SIZE', display: 'Byte', symbol: 'B', system: 'OTHER'},
    {key: 'KILOBYTE', type: 'DATA_SIZE', display: 'Kilobyte', symbol: 'KB', system: 'OTHER'},
    {key: 'MEGABYTE', type: 'DATA_SIZE', display: 'Megabyte', symbol: 'MB', system: 'OTHER'},
    {key: 'GIGABYTE', type: 'DATA_SIZE', display: 'Gigabyte', symbol: 'GB', system: 'OTHER'},
    {key: 'TERABYTE', type: 'DATA_SIZE', display: 'Terabyte', symbol: 'TB', system: 'OTHER'},
    {key: 'KIBIBYTE', type: 'DATA_SIZE', display: 'Kibibyte', symbol: 'KiB', system: 'OTHER'},
    {key: 'MEBIBYTE', type: 'DATA_SIZE', display: 'Mebibyte', symbol: 'MiB', system: 'OTHER'},
    {key: 'GIBIBYTE', type: 'DATA_SIZE', display: 'Gibibyte', symbol: 'GiB', system: 'OTHER'},
    {key: 'TEBIBYTE', type: 'DATA_SIZE', display: 'Tebibyte', symbol: 'TiB', system: 'OTHER'},
];

export function unitsForType(typeKey: string): UnitOfMeasureEntry[] {
    return UNITS_OF_MEASURE.filter(u => u.type === typeKey);
}
